<template>
    <div>
        <div class="dataTables_wrapper dt-bootstrap4">
            <div class="row">
                <div class="col-sm-12 overflow-auto">
                    <table id="salesReportDateTable" class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(items, item, j) in commissionItems" :key="j">
                                <td>{{j+1}}</td>
                                <td>{{item}}</td>
                                <td>{{formatPrice(items.service)}}</td>
                                <td>{{formatPrice(items.product)}}</td>
                                <td>{{formatPrice(items.package)}}</td>
                                <td>{{formatPrice(items.discount)}}</td>
                                <td>{{formatPrice(items.outstandings)}}</td>
                                <td>{{formatPrice(items.total)}}</td>
                            </tr>
                            <tr>
                                <td colspan="2" class="border-top-bottom-2 text-right fw-700">{{$t('label.total')}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('service'))}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('product'))}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('package'))}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('discount'))}}</td>
                                <td class="border-top-bottom-2 fw-500">{{formatPrice(getTotal('outstandings'))}}</td>
                                <td class="border-top-bottom-2 fw-700">{{formatPrice(getTotal('total'))}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import _ from 'lodash';
import {formatPrice, dateRange, reorderObject, setAYearArr, setYearArr} from './../../../../assets/js/dashboard/utilities'
import {setSalesCommissionItems} from './../../../../assets/js/dashboard/salonReport/salonReport'
export default {
    name: "salesDate",
    props:{
        commissionSalesItem: { type: Array }
    },
    data(){
        return{
            commissionItems: {}, objTotal: {},
            isUpdated: false
        }
    },
    computed:{
        fields(){
            return[
                {key: "index", label: "#"},
                {key: "date", label: this.$i18n.t('table.header.date')},
                {key: "service", label: this.$i18n.t('salon_report.item_types.service')},
                {key: "product", label: this.$i18n.t('salon_report.item_types.product')},
                {key: "package", label: this.$i18n.t('salon_report.item_types.package')},
                {key: "discount", label: this.$i18n.t('salon_report.item_types.discount')},
                {key: "outstandings", label: this.$i18n.t('salon_report.item_types.outstandings')},
                {key: "total", label: this.$i18n.t('label.total')},
            ]
        },
    },
    methods:{
        formatPrice(p){
            return formatPrice(p);
        },
        rearrangeCommissionItems(items, startDate, endDate){
            let $vm = this
            const range = dateRange(startDate.toDate(), endDate.toDate())
            if(range.length < 365){
                var rangeArr = range.map(date => moment(date).format($vm.$msg.CST.DATE_FORMAT))

                for(var i=0; i<items.length; i++){
                    items[i]["formatDate"] = moment.unix(items[i].createDate).format(this.$msg.CST.DATE_FORMAT)

                }
                var group = _.groupBy(items, "formatDate")
                for(var j=0; j<rangeArr.length; j++){
                    if(!(rangeArr[j] in group)){
                        group[rangeArr[j]] = []
                    }
                }
                var reordered = reorderObject(group)
                this.commissionItems = setSalesCommissionItems(reordered)
            }else if(range.length == 366 || range.length == 365){
                var yearObj = setAYearArr(moment(startDate).format('YYYY'))
                var index = 0
                for(var m in yearObj){
                    for(var l=0; l<items.length; l++){
                        var createDate = new Date(items[l].createDate*1000);
                        if(createDate.getMonth() == index){
                            yearObj[m].push(items[l])
                        }
                    }
                    index++;
                }
                this.commissionItems = setSalesCommissionItems(yearObj)
            }else{
                var yearsObj = setYearArr(moment(startDate).format('YYYY'),moment(endDate).format('YYYY'))
                for(var y in yearsObj){
                    for(var x=0; x<items.length; x++){
                        var cDate = new Date(items[x].createDate*1000);
                        if(cDate.getFullYear() == y){
                            yearsObj[y].push(items[x])
                        }
                    }
                }
                this.commissionItems = setSalesCommissionItems(yearsObj)
            }
        },
        getTotal(type){
            var total = 0;
            for(var key in this.commissionItems){
                var item = this.commissionItems[key]
                for(var itemType in item){
                    if(itemType == type){
                        total += parseFloat(item[itemType].toFixed(2))
                    }
                }
            }
            return total       
        },

    },
}
</script>
<style scoped>
.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
</style>